/* Server ratios reserve space before lazy playback. Metadata also handles URL
   films and media replaced in Composer; it never changes desktop framing. */
(() => {
  const roots = new WeakSet();
  function connect(root) {
    if (roots.has(root)) return;
    roots.add(root);
    const watched = new WeakSet();
    const resize = new ResizeObserver(entries => entries.forEach(({ target, contentRect }) => {
      const chapter = target.closest('[data-experience-chapter]');
      if (chapter && target.closest('.srlm-chapter__primary'))
        chapter.style.setProperty('--lb-primary-height', `${contentRect.height}px`);
    }));
    function sync(frame) {
      const video = frame.querySelector('video');
      if (video?.videoWidth && video.videoHeight) {
        const ratio = String(video.videoWidth / video.videoHeight);
        frame.style.setProperty('--native-film-ratio', ratio);
        frame.closest('.srlm-experience__cover')?.style.setProperty('--lb-native-cover', ratio);
      }
      if (!watched.has(frame)) { watched.add(frame); resize.observe(frame); }
    }
    function scan() { root.querySelectorAll('[data-native-film]').forEach(sync); }
    root.addEventListener('loadedmetadata', event => {
      const frame = event.target.closest('[data-native-film]');
      if (frame) sync(frame);
    }, true);
    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; scan(); });
    });
    observer.observe(root, { childList: true, subtree: true });
    scan();
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) { observer.disconnect(); resize.disconnect(); }
    });
  }
  function init() { document.querySelectorAll('.srlm-experience--lookbook').forEach(connect); }
  init();
  document.addEventListener('shopify:section:load', init);
})();
